import React from 'react';
import PropTypes from 'prop-types';

export const EmptyShippingMessage = ({ isGCC }) => {
  if (isGCC) { return <div className="shipping__empty__mw-whitespace" />; }
  return <div className="shipping__empty" />;
};

EmptyShippingMessage.propTypes = {
  isGCC: PropTypes.bool
};

EmptyShippingMessage.defaultProps = {
  isGCC: false
};
